export default __webpack_public_path__ + "static/media/attitudePieCharts.a5a2a879.png";